

import {useContext, useState} from 'react';
import ServiciosHogarPlanesContext from 'context/ServiciosHogarPlanesContext';
import {
 getAll,
 create,
 update,
 del
} from 'services/ServiciosHogarPlanesService.js'
import Swal from 'sweetalert2'


let itemsPerPage = 5;
let totalPages;


export function useServiciosHogarPlanes(){
 const [page, setPage] = useState(1);

 const {
  allHogarPlanes, 
  setAllHogarPlanes,
  hogarPlanes, 
  setHogarPlanes, 
  setMessage, 
  message,
  loading, 
  setLoading} = useContext(ServiciosHogarPlanesContext);

 
 const getAllHogarPlanes = async ({category, plan, unitPrice, comboPrice}) => {
  try{
   const response = await getAll({category, plan, unitPrice, comboPrice});
   setAllHogarPlanes(response)
   return response
  }catch(err){
   console.log(err);
   const {data, status} = err.response;
   setMessage({message: data.message, status});
  }
 }

 const getHogarPlanes = async ({page = 1, category, plan, unitPrice, comboPrice}) => {
     setLoading(true);
     setPage(page);
     try{
         const allHogarPlanes = await getAllHogarPlanes({category, plan, unitPrice, comboPrice});
         setAllHogarPlanes(allHogarPlanes);

         totalPages = Math.ceil(allHogarPlanes.length / itemsPerPage);
         const hogarPlanes = await getAll({page, limit: itemsPerPage, category, plan, unitPrice, comboPrice});
         setHogarPlanes(hogarPlanes);
         setLoading(false);
     }catch(err){
         console.log(err);
         const {data, status} = err.response;
         setMessage({message: data.message, status})
         setLoading(false);
     }
 }

 const deleteHogarPlan = async ({id, category}) => {
     Swal.fire({
     title: 'Estás seguro?',
     text: '¡No podrás revertir esto!',
     icon: 'warning',
     showCancelButton: true,
     confirmButtonColor: '#3085d6',
     cancelButtonColor: '#d33',
     confirmButtonText: 'Si, eliminar!',
     cancelButtonText: 'Cancelar'
     }).then((result) => {
     if (result.isConfirmed) {
        (async() => {
            try{
                const {message} = await del({id})
                setMessage({message: '', status: 200})                
                Swal.fire(
                'Éxito!!!',
                message,
                'success'
                )
                getHogarPlanes({page, category})
            }catch(err){
                const {data, status} = err.response
                setMessage({message: data.message, status})
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: data.message,
                })
            }
        })();
    }
    })
 }

 const updateHogarPlan = async ({hogarPlan, id, category}) => {
    try{
        const {message} = await update({hogarPlan, id})
        setMessage({message: '', status: 200})
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getHogarPlanes({page, category})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 const createHogarPlan = async ({hogarPlan, category}) => {
     try{
        const {message} = await create({hogarPlan})
        setMessage(state => ({...state, message}))
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getHogarPlanes({page, category})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 return {allHogarPlanes, hogarPlanes, page, totalPages, status: message.status, loading, deleteHogarPlan, updateHogarPlan, createHogarPlan, getHogarPlanes, setPage}
}